/**
 * Permission constants aligned with the Experience API specification.
 * These constants represent the exact permission strings returned by the API.
 */
export const PERMISSIONS = {
	// Business Intelligence permissions
	BROKER_ADMIN_USER: 'feat_boss_business_intelligence:user',
	BC_LISTING_METRICS_READ: 'bc_listing_metrics:read',
	CORE_USER: 'feat_boss_core:user',

	// Goal permissions (updated to match API spec)
	OT_GOALS_READ: 'ot_goals:read',
	OT_GOALS_UPDATE: 'ot_goals:update',

	// Feature permissions (updated to match API spec)
	RECRUITING_USER: 'feat_boss_recruiting:user',
	OFFICE_MANAGER_USER: 'feat_boss_agent_management:user',

	//AI assistance permissions
	AI_ASSISTANCE_ACCESS: 'ot_busintel_ai_assistant:read',
} as const

/**
 * Party type codes for permission queries.
 * These represent the different organizational levels for permission context.
 */
export const PartyTypeCd = {
	AGENT: 'AGENT',
	BROKER: 'BROKER',
	OFFICE: 'OFFICE',
} as const

export type PartyTypeCd = (typeof PartyTypeCd)[keyof typeof PartyTypeCd]

/**
 * Query parameters for fetching user permissions from the Experience API.
 */
export interface UserPermissionsQuery {
	/** The party ID (company/organization identifier) */
	partyId: string
	/** The party type code indicating the organizational level */
	partyTypeCd: PartyTypeCd
}

export interface PartyPermissions {
	/** The party ID (company/organization identifier) */
	partyId: string
	/** The party type code indicating the organizational level */
	partyTypeCd: PartyTypeCd
	/** The permissions granted to the partyId */
	accessPermissions: string[]
}

/**
 * Response structure for user permissions, including party-specific permissions.
 * Matches the exact API specification format.
 *
 * Note: the legacy Permit endpoint also returns a deprecated top-level
 * `accessPermissions` array, but the DASH endpoint does not — it is
 * intentionally omitted here so nothing can depend on it.
 */
export interface UserPermissionsResponse {
	userId: string
	partyPermissions: PartyPermissions[]
}
